import { enumToSelectItemsWithDisplayTextMap } from "web_modules/shared/FormHelpers/carbon-helpers";

/* eslint-disable import/prefer-default-export */
export enum MessageTemplate {
  MiscMessage = "misc_message",
  CreditPulledOnlyNOIA = "credit_pulled_only_noia",
  PreAppSuspenseNOIA = "pre_app_suspense_noia",
  PreAppSuspenseConditionsFollowUp = "pre_app_suspense_conditions_follow_up",
  PreAppApproval = "pre_app_approval",
  PreAppApprovalLowerLoanAmount = "pre_app_approval_lower_loan_amount",
  PreAppApprovalWithCashOffer = "pre_app_approval_with_cash_offer",
  PreAppApprovalWithCoTIApprovedBefore = "pre_app_approval_with_co_ti_approved_before",
  PreAppApprovalWithTIApprovedBefore = "pre_app_approval_with_ti_approved_before",
  PreAppApprovalWithTIUnapproved = "pre_app_approval_with_ti_unapproved",
  PreAppUpdatedApprovalOnceTIApproved = "pre_app_updated_approval_once_ti_approved",
  PreAppUpdatedApprovalOnceTIApprovedCo = "pre_app_updated_approval_once_ti_approved_co",
  PreAppExpiredApproval = "pre_app_expired_approval",
  RESPAInitialConditions = "respa_initial_conditions",
  RESPAConditionsFollowUp = "respa_conditions_follow_up",
  RESPASendingAppraisalAndConditionsFollowUp = "respa_sending_appraisal_and_conditions_follow_up",
  RESPASendingAppraisal = "respa_sending_appraisal",
  RESPAUpdatedAppraisal = "respa_updated_appraisal",
  PostClosingConditionsFollowUp = "post_closing_conditions_follow_up",
  IntroductionEmailEx = "introduction_email_ex",
  UWConditionFollowUpEmail = "uw_condition_follow_up_email",
  LMAllItemsReceivedEmail = "lm_all_items_received_email",
  LMConditionFollowUpEmail = "lm_condition_follow_up_email",
  RevisedLoanEstimateEmail = "revised_loan_estimate_email",
  InitialClosingDisclosureEmail = "initial_closing_disclosure_email",
  SigningClosingDisclosureEmail = "signing_closing_disclosure_email",
}

const {
  MiscMessage,
  CreditPulledOnlyNOIA,
  PreAppSuspenseNOIA,
  PreAppSuspenseConditionsFollowUp,
  PreAppApproval,
  PreAppApprovalLowerLoanAmount,
  PreAppApprovalWithCashOffer,
  PreAppApprovalWithCoTIApprovedBefore,
  PreAppApprovalWithTIApprovedBefore,
  PreAppApprovalWithTIUnapproved,
  PreAppUpdatedApprovalOnceTIApproved,
  PreAppUpdatedApprovalOnceTIApprovedCo,
  PreAppExpiredApproval,
  RESPAInitialConditions,
  RESPAConditionsFollowUp,
  RESPASendingAppraisalAndConditionsFollowUp,
  RESPASendingAppraisal,
  RESPAUpdatedAppraisal,
  PostClosingConditionsFollowUp,
  IntroductionEmailEx,
  UWConditionFollowUpEmail,
  LMAllItemsReceivedEmail,
  LMConditionFollowUpEmail,
  RevisedLoanEstimateEmail,
  InitialClosingDisclosureEmail,
  SigningClosingDisclosureEmail,
} = MessageTemplate;

const messageTemplateToDisplayText = {
  [MiscMessage]: "Miscellaneous Message",
  [CreditPulledOnlyNOIA]: "Credit Pulled Only NOIA",
  [PreAppSuspenseNOIA]: "Pre App Suspense NOIA",
  [PreAppSuspenseConditionsFollowUp]: "Pre App Suspense Conditions Follow Up",
  [PreAppApproval]: "Pre App Approval",
  [PreAppApprovalLowerLoanAmount]: "Pre App Approval Lower Loan Amount",
  [PreAppApprovalWithCashOffer]: "Pre App Approval With Cash Offer",
  [PreAppApprovalWithCoTIApprovedBefore]: "Pre App Approval With CO & TI Approved Before",
  [PreAppApprovalWithTIApprovedBefore]: "Pre App Approval With TI Approved Before",
  [PreAppApprovalWithTIUnapproved]: "Pre App Approval With TI Unapproved (TI only or TI/CO)",
  [PreAppUpdatedApprovalOnceTIApproved]: "Pre App Updated Approval Once TI Approved",
  [PreAppUpdatedApprovalOnceTIApprovedCo]: "Pre App Updated Approval Once TI Approved & CO",
  [PreAppExpiredApproval]: "Pre App Expired Approval",
  [RESPAInitialConditions]: "RESPA Initial Conditions",
  [RESPAConditionsFollowUp]: "RESPA Conditions FollowUp",
  [RESPASendingAppraisalAndConditionsFollowUp]: "RESPA Sending Appraisal And Conditions Follow Up",
  [RESPASendingAppraisal]: "RESPA Sending Appraisal",
  [RESPAUpdatedAppraisal]: "RESPA Updated Appraisal",
  [PostClosingConditionsFollowUp]: "Post Closing Conditions Follow Up",
  [IntroductionEmailEx]: "Introduction Email Ex",
  [UWConditionFollowUpEmail]: "UW Condition Follow Up Email",
  [LMAllItemsReceivedEmail]: "LM All Items Received Email",
  [LMConditionFollowUpEmail]: "LM Condition Follow Up Email",
  [RevisedLoanEstimateEmail]: "Revised Loan Estimate Email",
  [InitialClosingDisclosureEmail]: "Initial Closing Disclosure Email",
  [SigningClosingDisclosureEmail]: "Signing Closing Disclosure Email",
};

export const MessageTemplatesOptions = enumToSelectItemsWithDisplayTextMap(
  MessageTemplate,
  messageTemplateToDisplayText,
);
